<template>
    <section class="auth">
      <div class="brand"><img src="~@/assets/brand.svg"></div>
      <div class="user">

         <form>
           <input type="text" placeholder="usuario" ref="inputUser" v-model="inputUser" />
           <input type="password" placeholder="contraseña" ref="inputPass" v-model="inputPass"/>
           <div class="alert" ref="alert">¡ERROR! - <span ref="errormsg">Usuario y/o contraseña invalidos</span></div>
           <div class="actions">
              <a href="javascript:void(0)" class="btn accept large" @click="onClickAuth">INGRESAR</a>
            </div>
            <p><span>GuardOne</span> v1.0.1</p>
         </form>
      </div>
    </section>
</template>


<style scoped>
section { max-width:768px; margin:auto; padding-bottom:200px; padding-top:150px; }
.brand { width:60%; margin:auto;}
form { text-align:center; width:80%; margin:auto; margin-top:60px; }
form h1 { font-weight: 500; font-weight: 400 ; font-size:20px;}
form p { color:#555;}
form input { background:#eeeeee; display:block; border:#e4e4e4 solid 1px;  border-radius: 3px; padding:12px 15px; display: block; margin-bottom:20px; width: 100%; }
.actions { margin-top:50px;}
a.btn {background: #00b589; border-radius:6px; display:inline-block;  color:#fff; text-align:center; padding:20px 10px; font-size:11px; font-weight:bold; letter-spacing:1px; min-width:120px; }
a.btn.large { display:inline-block; min-width:200px; }
 form .alert { background-color:#e74c3c; font-size:14px; padding:5px; color:#fff; font-weight:bold; display:none; border-radius:3px;opacity:0; transition: opacity 0.5s ease; margin-top:5px;
 }
 form .alert.on { display:inline-block; opacity:1;  }
form .alert span { font-weight:500;}
</style>


<script>
import axios from 'axios'

export default {
  name: 'AuthView',
  components: {},
  data(){
    return{
      inputUser: '',
      inputPass: '',
      results:[],

    };
  },

  methods : {

    onClickAuth : function(){
      this.$refs.alert.classList.remove("on");
    axios({
      method: 'post',
      url: 'https://evotrack.com.mx/remote/ctrl.auth.php',
      headers: { 'content-type': 'application/x-www-form-urlencoded',  },
      data: { exec:"auth", data : { username: this.inputUser, password: this.inputPass } },
    }).then((response) => {
      this.results = response.data;
      if(this.results.status==202){

        localStorage.setItem("userToken",JSON.stringify(this.results));
        this.$router.push({ path: '/' });
        this.$root.setLogged(true,this.results);
      }else{
        this.$refs.alert.classList.add("on");
        localStorage.removeItem("userToken");
      }


    }).catch(function(){ });
  }

},

}
</script>
